import React      from 'react';
import classNames from 'classnames';

import styles   from './Ribbon.css';
import { Game } from '../../models/Game';

type RibbonProps = {
    game: Game,
    size: 'small' | 'large';
    className?: string;
};

export class Ribbon extends React.PureComponent<RibbonProps> {
    render() {
        const { game, size, className } = this.props;
        const isNew = game.isNew();
        
        if (!isNew) {
            return null;
        }



        return (
            <div
                className = {
                    classNames(
                        styles.ribbon,
                        styles.ribbonNew,
                        styles.ribbonNew,
                        { [styles.small]: size === 'small' },
                        className)
                }
            >
             {
                    'NEW'
             }
            </div>
        );
    }
}
